import { API } from "../../constAPI";

const headers = (token) => ({ Authorization: `token ${token}`, Accept: "application/json", "Content-Type": "application/json" });

const parse = async (response) => {
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || "Request failed");
  return data;
};

export const getCoachMatchRequests = (filters, token) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => value && params.set(key, value));
  return fetch(`${API}/api/admin/coach-match-requests?${params}`, { headers: headers(token) }).then(parse);
};

export const getCoachMatchActivity = (filters, token) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => value && params.set(key, value));
  return fetch(`${API}/api/admin/coach-match-requests/activity?${params}`, { headers: headers(token) }).then(parse);
};

export const updateCoachMatchRequest = (id, payload, token) => fetch(
  `${API}/api/admin/coach-match-requests/${id}`,
  { method: "PATCH", headers: headers(token), body: JSON.stringify(payload) }
).then(parse);

export const getCoachFunnel = (filters, token) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => value && params.set(key, value));
  return fetch(`${API}/api/admin/coach-match-requests/funnel?${params}`, { headers: headers(token) }).then(parse);
};
